import React, { useState, useEffect, useRef } from 'react'
import {Row,Col,Image} from 'react-bootstrap'
import { Link, useNavigate, useParams } from 'react-router-dom'
import Card from '../../../../components/Card'
import { API_IVR_LIST, API_IVR_DELETE } from '../../../../service/url';
import { getApiCall, deleteApiCallWithHeader , postApiCall, fetchAndSetFlashMessage} from '../../../../service/httpCall';
import { DataTable } from 'primereact/datatable';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { Column } from 'primereact/column';
import ToastNotification from '../../../../components/Toast';
import { toast } from 'react-toastify';
import { ROUTES } from '../../../../utilities/constant';
import { EditIcon, DeleteIcon } from '../../../../components/setting/elements';
import RenderDeleteModal from '../../../../components/partials/components/delete-modal';
import Loader  from '../../../../components/partials/components/loader';
import { useAuth, errorCheck } from '../../auth/auth-utils';
import { Checkbox } from 'primereact/checkbox';
import { Button } from 'primereact/button';
import "../../../../assets/custom/css/custom.css";
import exportData from '../../../../utilities/export';
//theme
import 'primereact/resources/themes/lara-light-indigo/theme.css';
//core
import 'primereact/resources/primereact.min.css';
import { USER_ROLES, MODULE_ACL,FLASH_MESSAGE_ACTION_OBJECT } from '../../../../utilities/constant';
import { getUser } from "../../../../utilities/setting";


const IvrList = () => {
   const { checkAuth } = useAuth();
   const navigate = useNavigate();
   const { cid } = useParams();

   const [IvrList, setIvrList] = useState([]);
   const [showToast, setShowToast] = useState(false);
   const [toastProps, setToastProps] = useState(null);
   const [filters, setFilters] = useState({
      name: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] }
   });
   const [enableDeleteModal, setEnableDeleteModal] = useState(false);
   const [confirmDelete, setConfirmDelete] = useState(false);
   const [deleteIvrId, setDeleteIvrId] = useState(undefined);
   const [loading, setLoading] = useState(false);
   const [selectedIVR, setSelectedIVR] = useState([]);
   const [isMultiDelete, setIsMultiDelete] = useState(false);
   const [buttonDisable, setButtonDisable] = useState(false);
   const [loggedInUserACL, setLoggedInUserACL] = useState({})
   const [isSuperAdmin, setIsSuperadmin] = useState(false)
   const [alertMessage, setAlertMessage] = useState(null);

   const handleExport = async () => {
      setButtonDisable(true); 
      await exportData('IVR', setToastProps, setShowToast);
      setButtonDisable(false); 
   };
  
    const handleCheckboxToggle = (ivrId) => {
      const isSelected = selectedIVR.includes(ivrId);
      setSelectedIVR(isSelected
          ? selectedIVR.filter(id => id !== ivrId)
          : [...selectedIVR, ivrId]);
    };
  
    const handleMultiDelete = () => {
          setIsMultiDelete(true);
          setEnableDeleteModal(true);
    };


   useEffect( () => {
      setLoading(true);
      getUser().then((user) => {
         if (user.role === USER_ROLES.SUPERADMIN) {
            setIsSuperadmin(true);
         }

         if (user?.acl_settings) {
            setLoggedInUserACL(JSON.parse(user.acl_settings.module_operations));
         }
           });
      const apiIvrListUrl = API_IVR_LIST.replace(':cid', cid);
      getApiCall(apiIvrListUrl, {})
      .then(onIvrListSuccess)
      .catch(onError)
      .finally(() => setLoading(false));

      fetchAndSetFlashMessage(
            msg => msg.module_name === MODULE_ACL.IVR && msg.action === FLASH_MESSAGE_ACTION_OBJECT.LIST && msg.type === 'Flash Message',
            setAlertMessage
      );
   }, []);

   // useEffect( () => {

   //    if(toastProps){
   //       setShowToast(true);
   //    }

   // }, [toastProps]);

   const handleSelectAll = () => {
      if (selectedIVR.length === IvrList.length) {
          setSelectedIVR([]);
      } else {
          const allAclIds = IvrList.map(ivr => ivr.flow_id);
          setSelectedIVR(allAclIds);
      }
    };

    useEffect( () => {
      if (confirmDelete) {
          if (isMultiDelete) {
              postApiCall(API_IVR_DELETE.replace(':cid', cid), { ivrIds: selectedIVR})
                  .then(onDeleteSuccess)
                  .catch(onDeleteFail);
          } else {
              postApiCall(API_IVR_DELETE.replace(':cid', cid), { ivrIds: [deleteIvrId]})
                  .then(onDeleteSuccess)
                  .catch(onDeleteFail);
          }
      }
      }, [confirmDelete]);

    function onDeleteSuccess(resp){
      const { deleted = [], notDeleted = [] } = resp;

      toast.success(
      <div>
         {deleted.length > 0 && (
            <div>
            <strong>Deleted:</strong> {deleted.join(", ")}
            </div>
         )}

         {notDeleted.length > 0 && (
            <div style={{ marginTop: "5px" }}>
            <strong>Not deleted:</strong>
            {notDeleted.map((item, index) => (
               <div key={index}>
                  {item.ivrName} ({item.reason})
               </div>
            ))}
            </div>
         )}
      </div>
      );
        let updatedList;
         if (isMultiDelete) {
            updatedList = IvrList.filter(val => !selectedIVR.includes(val.flowId)).map((val, key) => {
                  val['key'] = key + 1;
                  return val;
            });
         } else {
            updatedList = IvrList.filter(val => val.flowId != deleteIvrId).map( (val, key) => {
               val['key'] = key+1;
               return val;
            });
         }

         setLoading(true);
         const apiIvrListUrl = API_IVR_LIST.replace(':cid', cid);
         getApiCall(apiIvrListUrl, {})
         .then(onIvrListSuccess)
         .catch(onError)
         .finally(() => setLoading(false));

        setIvrList(updatedList);
        setIsMultiDelete(false);
        setEnableDeleteModal(false);
        setDeleteIvrId(undefined);
        setConfirmDelete(false)
     }
  
     function onDeleteFail(err){
      if (typeof err !== 'object' && err.includes('TokenExpiredError')) {
         errorCheck(err, navigate, setToastProps, setShowToast)
      } else {
          toast.warning(`Unable to delete IVR: ${err}`)
      }
     }


   function onIvrListSuccess(resp){
      for(let idx in resp){
        resp[idx]['key'] = Number(idx)+1;
      //   resp[idx]['actions'] = RenderActionComponent(resp[idx].id);
        resp[idx]['created_at'] = new Date(resp[idx]['created_at']).toGMTString();
      }
      setIvrList(resp);
   }

    function handleDeleteIVR(id){
      checkAuth(setToastProps, setShowToast)
      setIsMultiDelete(false);
        setEnableDeleteModal(true);
        setDeleteIvrId(id);
    }

    const RenderActionComponent = ({id}) => {
      const editUrl = ROUTES.IVR.EDIT.replace(':id', id).replace(':cid', cid);

      return (
        <div className="flex align-items-center list-user-action">
         {(isSuperAdmin || loggedInUserACL[MODULE_ACL.IVR]?.edit) && (
            <EditIcon linkTo={`/${editUrl}`}/>
         )}   
            {' '}
         {!(selectedIVR.length > 0) &&
         (isSuperAdmin || loggedInUserACL?.[MODULE_ACL.IVR]?.delete) && (
            <DeleteIcon handleCallback={() => handleDeleteIVR(id)} />
         )}

            {' '}
        </div>
      );

   }

//    const dropdownItemTemplate = (option) => {
//       return <span>{option}</span>;
//    }

//    const statusFilterTemplate = (options) => {
//       return <Dropdown value={options.value} options={statuses.current} onChange={(e) => options.filterCallback(e.value, options.index)} itemTemplate={dropdownItemTemplate} placeholder="Select One" className="p-column-filter" showClear />;
//    }

function onError(err) {
   if (typeof err !== 'object' && err.includes('TokenExpiredError')) {
      errorCheck(err, navigate, setToastProps, setShowToast)
   } else {
     console.log(err)
   }
}

const handleCreateButtonClick = () => {
   const createUrl = ROUTES.IVR.CREATE.replace(':cid', cid);
   navigate(`/${createUrl}`);
}

const rowClassName = (data) => {
   return {
       'highlighted-row': selectedIVR.includes(data.id)
     };
 }


 const actionBodyTemplate = (rowData) => {
   return <RenderActionComponent id={rowData.flow_id} />;
};
   
 if (loading) {
   return <Loader />
}

  return(
     <>
        {alertMessage && <marquee className="fade alert alert-success show" style={{marginTop : '5px'}}>{alertMessage}</marquee>}

       <div>
         <Row>
            <Col sm="12">
               <Card>
                  <Card.Header className="d-flex justify-content-between">
                     <div className="header-title">
                        <h4 className="card-title">IVR List</h4>
                     </div>
                     {(isSuperAdmin || loggedInUserACL[MODULE_ACL.IVR]?.add) && (
                        <button className="btn btn-primary ml-auto" onClick={handleCreateButtonClick}>Create IVR</button>
                     )}
                  </Card.Header>
                  <Card.Body className="px-0">
                  <div className="scroll-container">
                     <div className="table-responsive border-bottom my-3">
                        {((isSuperAdmin || loggedInUserACL?.[MODULE_ACL.IVR]?.delete)) && (
                           <Button 
                              label="Delete Selected" 
                              onClick={handleMultiDelete} 
                              className="p-button-danger p-button-sm" 
                              style={{ marginBottom: '10px', marginLeft: '10px' }} 
                              disabled={selectedIVR.length === 0} 
                           />
                        )}
                        {IvrList.length > 0 && <Button 
                           label="Export Data" 
                           onClick={handleExport} 
                           className="p-button-active p-button-sm" 
                           style={{ marginBottom: '10px', marginLeft: '10px' }} 
                           disabled={buttonDisable} 
                        >
                           &nbsp;
                           {buttonDisable && (
                              <span className="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>
                           )}
                        </Button>}
                        
                        <DataTable value={IvrList} tableStyle={{ minWidth: '50rem' }} filters={filters} paginator rows={8} rowClassName={rowClassName}>
                           <Column 
                              header={<Checkbox 
                              checked={selectedIVR.length === IvrList.length && IvrList.length > 0} 
                              onChange={handleSelectAll} 
                              />} 
                              headerStyle={{ width: '3rem' }} 
                              body={(rowData) => (
                              <Checkbox 
                                 checked={selectedIVR.includes(rowData.flow_id)} 
                                 onChange={() => handleCheckboxToggle(rowData.flow_id)} 
                              />
                              )} 
                           />
                           <Column field="flow_name" filterField="name" header="Flow Name"></Column>
                           <Column field="created_at" header="Created At" body={(rowData) =>
                                    new Date(rowData.created_at).toLocaleString("en-IN", {
                                       day: "2-digit",
                                       month: "short",
                                       year: "numeric",
                                       hour: "2-digit",
                                       minute: "2-digit",
                                       second: "2-digit",
                                    })
                                 }></Column>
                           <Column field="updated_at" header="Last Updated At" body={(rowData) =>
                                    new Date(rowData.updated_at).toLocaleString("en-IN", {
                                       day: "2-digit",
                                       month: "short",
                                       year: "numeric",
                                       hour: "2-digit",
                                       minute: "2-digit",
                                       second: "2-digit",
                                    })
                                 }></Column>
                           <Column
                              field="status"
                              header="Status"
                              body={(rowData) => (
                                 <span>
                                    {rowData.status == 1 ? "Complete" : "Pending"}
                                 </span>
                              )}
                           />
                           <Column header="Action" body={actionBodyTemplate} />
                        </DataTable>
                     </div>
                  </div>
                  </Card.Body>
               </Card>
            </Col>
         </Row>
      </div>

      <RenderDeleteModal 
         show={enableDeleteModal} 
         setShow={setEnableDeleteModal} 
         setConfirmDelete={setConfirmDelete} 
         isMultiDelete={isMultiDelete} 
         clearSelectedData={() => setSelectedIVR([])}
      />

      {/* <ToastNotification show_toast={showToast} set_show_toast={setShowToast} {...toastProps} /> */}

     </>
  )

}

export default IvrList;